import {
  INVOICES_FETCH_FAILURE,
  INVOICES_FETCH_REQUEST,
  INVOICES_FETCH_SUCCESS,
  INVOICES_ADD_FAILURE,
  INVOICES_ADD_REQUEST,
  INVOICES_ADD_SUCCESS,
  INVOICES_UPDATE_FAILURE,
  INVOICES_UPDATE_REQUEST,
  INVOICES_UPDATE_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  invoices: [],
  totalInvoices: 0,
  loading: false,
  error: null,
};

const InvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVOICES_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case INVOICES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: action.payload.invoices,
        totalInvoices: action.payload.totalInvoices, 
      };

    case INVOICES_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case INVOICES_ADD_REQUEST:
      return { ...state, loading: true, error: null };

    case INVOICES_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: [...state.invoices, action.payload],
      };

    case INVOICES_ADD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case INVOICES_UPDATE_REQUEST:
      return { ...state, loading: true, error: null };

    case INVOICES_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoices: state.invoices.map((invoice) =>
          invoice.id === action.payload.id ? action.payload : invoice
        ), 
      };

    case INVOICES_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default InvoicesReducer;
